import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { UserContext } from '../user-context.model';

export const UserContextActions = createActionGroup({
  source: 'User Context',
  events: {
    'Load Context': emptyProps(),
    'Load Context Success': props<{ context: UserContext }>(),
    'Load Context Failure': props<{ error: string }>(),
    /** In-app org switch from the side-nav switcher (calls POST /auth/switch-org). */
    'Switch Org': props<{ orgId: number }>(),
    /** Emitted after the active org changed — features reload their data on this. */
    'Org Changed': props<{ orgId: number }>(),
  },
});
